import React, { useEffect, useState } from "react";
import Close from "../../../../../Icons/Close";
import ModalOk from "../../../../../components/compte/ModalMdpOk";
import { useForm } from "react-hook-form";
import Classnames from "classnames";
import srcIconCheck from "../../../../../styles/img/icon-check-white.svg";
import Img from "react-image";
import jwt_decode from "jwt-decode";
import { fadeIn, fadeOut } from "react-animations";
import Radium, { StyleRoot } from "radium";
import _ from "lodash";
const styles = {
  bounce: {
    animation: "x 0.5s",
    animationName: Radium.keyframes(fadeIn, "fadeIn"),
    background: "rgba(0, 76, 197, 0.7)",
  },
  bounce2: {
    animation: "x 0.5s",
    animationName: Radium.keyframes(fadeOut, "fadeOut"),
    background: "rgba(0, 76, 197, 0.7)",
  },
};

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;

export default function ModalAjoutStaff(props) {
  const [styleFadeIn, setFadeIn] = useState(true);
  const [isOpenAdminAdd, setAdminAdd] = useState(false);
  const [isOpenChangeAdmin, setChangeAdmin] = useState(false);
  const [isOpenLastAdmin, setChangeLastAdmin] = useState(false);
  const [buttonValid, setButtonValid] = useState(false);
  const [selectedSectionIds, setSelectedSectionIds] = useState(
    props.agent.sections ? props.agent.sections.map((s) => s.id) : []
  );
  const [accesToutesLesSections, setAccesToutesLesSections] = useState(
    props.agent.accesToutesLesSections || false
  );
  const [valuesForm, setValuesForm] = useState({
    prenom: props.agent.prenom,
    nom: props.agent.nom,
    email: props.agent.email,
    numeroTel: props.agent.numeroTel,
    typeCompte: props.agent.typeCompte,
    fonction: props.agent.fonction,
    email: props.agent.email,
  });
  useEffect(() => {
    if (
      !_.isEmpty(valuesForm.prenom) &&
      !_.isEmpty(valuesForm.nom) &&
      !_.isEmpty(valuesForm.email) &&
      !_.isEmpty(valuesForm.numeroTel) &&
      !_.isEmpty(valuesForm.typeCompte) &&
      !_.isEmpty(valuesForm.fonction)
    ) {
      setButtonValid(true);
    } else {
      setButtonValid(false);
    }
  }, [valuesForm]);
  let token = localStorage.getItem("token");
  let tokenDecoded = token ? jwt_decode(token) : "";

  const { handleSubmit, register, errors, setValue } = useForm({
    defaultValues: {
      prenom: props.agent.prenom,
      nom: props.agent.nom,
      email: props.agent.email,
      numeroTel: props.agent.numeroTel,
      typeCompte: props.agent.typeCompte,
      fonction: props.agent.fonction,
      email: props.agent.email,
    },
  });
  const onSubmit = (values) => {
    if (
      values.typeCompte === "ADMIN_CRECHE" &&
      props.agent.typeCompte !== "ADMIN_CRECHE" &&
      tokenDecoded.AGENT_ID !== props.agent.id
    ) {
      setAdminAdd(true);
    } else if (
      values.typeCompte !== "ADMIN_CRECHE" &&
      tokenDecoded.AGENT_ID === props.agent.id
    ) {
      let numAdmins = props.listAgents.reduce((acc, currVal) => {
        return currVal.typeCompte === "ADMIN_CRECHE" && currVal.agentActif
          ? acc + 1
          : acc;
      }, 0);
      if (numAdmins > 1) {
        setChangeAdmin(true);
      } else {
        setChangeLastAdmin(true);
      }
    } else {
      let data = Object.assign({}, props.agent, {
        prenom: values.prenom,
        nom: values.nom,
        email: values.email,
        numeroTel: values.numeroTel,
        typeCompte: values.typeCompte,
        fonction: values.fonction,
        email: values.email,
        idPhoto: null,
      });
      delete data.id;
      delete data.urlPhoto;
      delete data.etatCompte;
      delete data.agentActif;
      delete data.horairesDetails;
      delete data.sections;
      delete data.accesToutesLesSections;
      props.submitModifStaff(data, props.agent.id, false);
      handleSaveSections();
    }
  };
  const handleChange = (e) => {
    setValue(e.target.name, e.target.value);
    setValuesForm({ ...valuesForm, [e.target.name]: e.target.value });
  };
  const handleSectionToggle = (sectionId) => {
    setSelectedSectionIds((prev) =>
      prev.includes(sectionId)
        ? prev.filter((id) => id !== sectionId)
        : [...prev, sectionId]
    );
  };
  const handleSaveSections = () => {
    const token = localStorage.getItem("token");
    props.updateAgentSections(token, props.agent.id, {
      sectionIds: accesToutesLesSections ? [] : selectedSectionIds,
      accesToutesLesSections: accesToutesLesSections,
    });
  };
  const onSubmitAdminAdd = () => {
    let data = Object.assign({}, props.agent, {
      prenom: valuesForm.prenom,
      nom: valuesForm.nom,
      email: valuesForm.email,
      numeroTel: valuesForm.numeroTel,
      typeCompte: valuesForm.typeCompte,
      fonction: valuesForm.fonction,
      email: valuesForm.email,
      idPhoto: null,
    });
    delete data.id;
    delete data.urlPhoto;
    delete data.etatCompte;
    delete data.agentActif;
    delete data.horairesDetails;
    delete data.sections;
    delete data.accesToutesLesSections;
    props.submitModifStaff(data, props.agent.id, false);
    handleSaveSections();
    setAdminAdd(false);
  };
  const onSubmitAdminAndLogout = () => {
    let data = Object.assign({}, props.agent, {
      prenom: valuesForm.prenom,
      nom: valuesForm.nom,
      email: valuesForm.email,
      numeroTel: valuesForm.numeroTel,
      typeCompte: valuesForm.typeCompte,
      fonction: valuesForm.fonction,
      email: valuesForm.email,
      idPhoto: null,
    });
    delete data.id;
    delete data.urlPhoto;
    delete data.etatCompte;
    delete data.agentActif;
    delete data.horairesDetails;
    delete data.sections;
    delete data.accesToutesLesSections;
    props.submitModifStaff(data, props.agent.id, true);
    handleSaveSections();
    setChangeAdmin(false);
  };
  const onSubmitLastAdmin = () => {
    setValuesForm({
      prenom: props.agent.prenom,
      nom: props.agent.nom,
      email: props.agent.email,
      numeroTel: props.agent.numeroTel,
      typeCompte: props.agent.typeCompte,
      fonction: props.agent.fonction,
      email: props.agent.email,
    });
    setChangeLastAdmin(false);
  };
  const closeModal = () => setAdminAdd(false);
  const ConfirmationReset = () => {
    if (isOpenAdminAdd || isOpenChangeAdmin || isOpenLastAdmin) {
      setAdminAdd(false);
      setChangeAdmin(false);
      setChangeLastAdmin(false);
    }
  };

  return (
    <StyleRoot>
      <div
        style={styleFadeIn === true ? styles.bounce : styles.bounce2}
        className="modal fade modal-skin modalAddStaff show"
        id="modalAddStaff"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modalAddStaff"
        aria-hidden="true"
      >
        {isOpenAdminAdd ? (
          <ModalOk
            title={"Modifier les droits d'accès"}
            button={"Confirmer"}
            message={
              "Etes-vous sûr de vouloir ajouter un administrateur? Cet utilisateur aura exactement les mêmes droits d'accès que vous."
            }
            closeModal={ConfirmationReset}
            handleSubmit={onSubmitAdminAdd}
          />
        ) : (
          ""
        )}
        {isOpenChangeAdmin ? (
          <ModalOk
            title={"Modifier les droits d'accès"}
            button={"Confirmer"}
            message={
              "Etes-vous sûr de vouloir renoncer à vos droits administrateur? Si vous confirmez la modification vous serez invité à vous connecter de nouveau."
            }
            closeModal={ConfirmationReset}
            handleSubmit={onSubmitAdminAndLogout}
          />
        ) : (
          ""
        )}
        {isOpenLastAdmin ? (
          <ModalOk
            button={"OK"}
            title={"Modifier les droits d'accès"}
            message={
              "Vous êtes le seul administrateur du compte de votre crèche. Le compte de la crèche doit avoir au moins un administrateur."
            }
            closeModal={ConfirmationReset}
            handleSubmit={onSubmitLastAdmin}
          />
        ) : (
          ""
        )}
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit(onSubmit)}>
              <button
                onClick={props.onClose}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close className="img-fluid" alt="" />{" "}
              </button>
              <div className="modal-body">
                <h5 className="modal-title mt-0">Modifier les informations</h5>
                <section className="content-section pt-3 pb-0 mb-0 border-0">
                  <div className="row">
                    <div className="col-md-6 pl-2">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.prenom,
                        })}
                      >
                        <input
                          defaultValue={props.agent.prenom}
                          onChange={handleChange}
                          type="text"
                          className="form-control box-shadow custom-input ipt-id-nom"
                          name="prenom"
                          ref={register({
                            required: "Ce champs est obligatoire!",
                          })}
                          placeholder="Prénom"
                        />
                        {errors.prenom && errors.prenom.message && (
                          <p>{errors.prenom.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 pr-2">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.nom,
                        })}
                      >
                        <input
                          defaultValue={props.agent.nom}
                          onChange={handleChange}
                          type="text"
                          className="form-control box-shadow custom-input ipt-id-nom"
                          name="nom"
                          ref={register({
                            required: "Ce champs est obligatoire!",
                          })}
                          placeholder="Nom"
                        />
                        {errors.nom && errors.nom.message && (
                          <p>{errors.nom.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.email,
                        })}
                      >
                        <input
                          defaultValue={props.agent.email}
                          disabled={props.agent.etatCompte === "CONFIRMER"}
                          onChange={handleChange}
                          type="text"
                          className="form-control box-shadow custom-input ipt-id-email"
                          name="email"
                          ref={register({
                            required: "Ce champs est obligatoire!",
                            pattern: {
                              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                              message: "Adresse mail invalide!",
                            },
                          })}
                          placeholder="Email"
                        />
                        {errors.email && errors.email.message && (
                          <p>{errors.email.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.numeroTel,
                        })}
                      >
                        <input
                          defaultValue={props.agent.numeroTel}
                          onChange={handleChange}
                          type="text"
                          className="form-control box-shadow custom-input ipt-id-tel"
                          name="numeroTel"
                          ref={register({
                            required: "Ce champs est obligatoire!",
                            pattern: {
                              value: /^(\+?)\d{7,}/i,
                              message: "Numéro de téléphone invalide!",
                            },
                          })}
                          placeholder="Téléphone"
                        />
                        {errors.numeroTel && errors.numeroTel.message && (
                          <p>{errors.numeroTel.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.typeCompte,
                        })}
                      >
                        <select
                          defaultValue={props.agent.typeCompte}
                          onChange={handleChange}
                          className="form-control box-shadow custom-select ipt-id-compte"
                          name="typeCompte"
                          ref={register({
                            required: "Ce champs est obligatoire!",
                          })}
                        >
                          <option value="">
                            Sélectionner un type de compte
                          </option>
                          <option value="ADMIN_CRECHE">Administrateur</option>
                          <option value="AGENT_CRECHE_CONFIRME">
                            Utilisateur avancé
                          </option>
                          <option value="AGENT_CRECHE_NON_CONFIRME">
                            Utilisateur
                          </option>
                        </select>
                        {errors.typeCompte && errors.typeCompte.message && (
                          <p>{errors.typeCompte.message}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div
                        className={Classnames("form-group", {
                          "error-mess": errors.fonction,
                        })}
                      >
                        <select
                          defaultValue={props.agent.fonction}
                          onChange={handleChange}
                          className="form-control box-shadow custom-select ipt-id-fonction"
                          name="fonction"
                          ref={register({
                            required: "Ce champs est obligatoire!",
                          })}
                        >
                          <option value="">Choisir une fonction</option>
                          <option value="DIRECTRICE">Directrice/teur</option>
                          <option value="PUERCULTIRCE">
                            Puéricultrice/teur
                          </option>
                          <option value="EDUCATRICE">Éducatric(e)</option>
                          <option value="INFERMIERE">Infirmière</option>
                          <option value="AUXILIAIRE_PUERICULTURE">
                            Assistant(e) Petite Enfance
                          </option>
                          <option value="CUISINERE">Cuisinier(e)</option>
                          <option value="ENTRETIEN">Agent d'entretien</option>
                          <option value="AUTRE">Autre</option>
                        </select>
                        {errors.fonction && errors.fonction.message && (
                          <p>{errors.fonction.message}</p>
                        )}
                      </div>
                    </div>
                    {props.allSections && props.allSections.length > 0 && (
                      <div className="col-md-12" style={{ marginTop: "8px" }}>
                        <label style={{ fontWeight: "bold", fontSize: "13px", marginBottom: "8px", display: "block" }}>
                          Sections
                        </label>
                        <div style={{ marginBottom: "8px" }}>
                          <label style={{ display: "flex", alignItems: "center", cursor: "pointer", fontSize: "13px" }}>
                            <input
                              type="checkbox"
                              checked={accesToutesLesSections}
                              onChange={(e) => setAccesToutesLesSections(e.target.checked)}
                              style={{ marginRight: "8px" }}
                            />
                            Accès à toutes les sections
                          </label>
                        </div>
                        {!accesToutesLesSections && (
                          <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                            {props.allSections.map((section) => {
                              const isSelected = selectedSectionIds.includes(section.id);
                              return (
                                <label
                                  key={section.id}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    padding: "4px 10px",
                                    borderRadius: "16px",
                                    border: `2px solid ${section.couleur || "#999"}`,
                                    backgroundColor: isSelected ? (section.couleur || "#999") : "transparent",
                                    color: isSelected ? "#fff" : (section.couleur || "#999"),
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    transition: "all 0.2s",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => handleSectionToggle(section.id)}
                                    style={{ display: "none" }}
                                  />
                                  {section.nom}
                                </label>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </section>
                <div className="d-flex justify-content-center mt-3" style={{ gap: "10px" }}>
                  <button
                    style={buttonValid ? { opacity: 1 } : { opacity: 0.25 }}
                    type="submit"
                    className="btn-gradient btn-valid"
                  >
                    <IconCheckWhite /> Valider
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}
